import React, { useState, useEffect } from "react";
import "./Contact.css";
import "aos/dist/aos.css";
import AOS from "aos";

const ContactUs = () => {
  const [submitted, setSubmitted] = useState(false);

  // Initialize AOS for animation
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    // Submit form data to FormSubmit API
    await fetch('https://formsubmit.co/lepicforuhh@gmail.com', {
      method: 'POST',
      body: data,
    });

    setSubmitted(true);
    form.reset();
  };

  return (
    <div className="contact-section" id="Contact">
      <div className="row g-0">
        {/* Left Section */}
        <div className="col-md-6 left-section" data-aos="fade-right">
          <div className="content">
            <h2>Let's Build the Future of <br /> <strong>Education Together</strong></h2>
            <p>
              Looking for the best educational resources? Need expert notes and guides for B.Tech,BCA courses? We're here to help you succeed.
            </p>
            <p className="call-us"><strong>📞 Contact us at:</strong> lepicforuhh@gmail.com</p>

            <h4>Why Choose Lepic?</h4>
            <ul className="benefits-list">
              <li> Detailed Notes for B.Tech Subjects</li>
              <li> Complete Syllabus Videos</li>
              <li> Solved Previous Year Questions (PYQs)</li>
              <li> One-shot and Full Course Videos</li>
              <li> Tailored Resources for Exam Success</li>
            </ul>

            <h4>How We Help?</h4>
            <div className="steps">
              <p><strong>1.</strong> Explore our videos and notes</p>
              <p><strong>2.</strong> Get detailed solutions and study material</p>
              <p><strong>3.</strong> Achieve your academic goals with ease!</p>
            </div>
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div className="col-md-6 d-flex align-items-center justify-content-center" data-aos="fade-left">
          <div className="contact-form">
            {submitted ? (
              <div className="thank-you text-center animate__animated animate__fadeIn">
                <h2 className=" mb-3">Thank you!</h2>
                <p>Your message has been sent successfully.</p>
              </div>
            ) : (
<form className="contact-form shadow-lg p-4 rounded animate__animated animate__fadeInUp" onSubmit={handleSubmit}>

                <h3 className="text-center mb-4">Get in Touch</h3>

                <div className="mb-3">
                  <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                </div>

                <div className="mb-3">
                  <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                </div>

                <div className="mb-3">
                  <textarea name="message" className="form-control" placeholder="Your Message" rows="5" required />
                </div>

                {/* Anti-spam */}
                <input type="hidden" name="_captcha" value="false" />

                <div className="d-grid">
                  <button type="submit" className="btn btn-primary btn-lg">Send Message</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
